import React from "react";
import BodyContainer from "../components/BodyContainer";
import BottomContainer from "../components/BottomContainer";
import Footer from "../components/Footer";
import Banner from "../components/Banner";
import FooterLinks from "../components/FooterLinks";
import bannerImage from "../assets/banner4.png";
import { Helmet } from "react-helmet-async";
import "../Site.css";
import "../About.css";
import "../Privacy.css";

function Privacy() {
  return (
    <>
      <Helmet>
        <title>PharmPrepPro - Privacy</title>
      </Helmet>
      <BottomContainer>
        <Banner height="300px" image={bannerImage} />
        <BodyContainer>
          <h1 className="white-text center-text-mobile">Privacy Policy</h1>

          <div className="privacy-content white-text">
            <p className="small-text">
              PharmPrepPro values the privacy of all individuals who use the website located at
              <a href="https://pharmpreppro.com" target="_blank" rel="noreferrer"> https://pharmpreppro.com</a>. This privacy statement ("Policy")
              outlines our current data handling practices. Any updates to this policy in the future will be published on this page.
            </p>

            <p className="small-text">
              In this policy, the terms "you" and "your" refer to individuals or organizations using and/or subscribing to our Service ("Users").
              The term “Service” refers to any present or future offerings from PharmPrepPro, whether free or paid.
              Unless otherwise noted, the terms "PharmPrepPro," "we," and "our" all refer collectively to PharmPrepPro.
            </p>

            <h2  style={{ marginTop: "20px" }}>Information We Collect</h2>
            <p className="small-text">We gather information when you visit our website or engage with our services. The personal data we collect may include:</p>
            <ul className="small-text">
              <li>Identifiers such as your name, email, or account name.</li>
              <li>Commercial details like the products or services you have purchased.</li>
              <li>Device and Network information such as your IP Address, device identifiers, browser and operating system information, and related log data.</li>
            </ul>

            <h2>Purpose</h2>
             <p className="small-text">
              We process this information for legitimate business purposes, including: (i) securing and maintaining the Site; (ii) detecting, investigating, and preventing fraud, abuse, and unauthorized access; (iii) protecting our intellectual property and preventing unauthorized copying or distribution of content; and (iv) enforcing our Terms and other agreements.
            </p>
            <h2>Information You Provide</h2>
            <p className="small-text">
              When you register or request details from us, we collect personally identifiable information via our sign-up or enrollment forms.
              Additionally, personal data shared via email or offline may also be collected. Any voluntary data you provide is your responsibility.
            </p>
            <p className="small-text">
              If you use our services, we may also collect:
              <ul className="small-text">
                <li>Your subscription type and service interactions.</li>
                <li>Queries submitted with timestamps.</li>
                <li>Content you post: answers, notes, flash cards, forum messages, etc.</li>
              </ul>
            </p>

            <h2>How We Use Collected Information</h2>
            <ul className="small-text">
              <li>To execute and support the reason the information was provided.</li>
              <li>To improve site content and services.</li>
              <li>To develop new features and analyze usage.</li>
              <li>To personalize your experience.</li>
              <li>To notify you of updates (if opted in).</li>
              <li>To communicate marketing messages (with consent).</li>
              <li>To manage payments and prevent fraud.</li>
              <li>To enforce policies and protect rights.</li>
              <li>To derive insights and create user profiles.</li>
            </ul>

            <h2>How is the Information Shared</h2>
            <p className="small-text">
              We may disclose information if required by law, in corporate transitions, or to prevent misuse. We do not sell your personal data.
              Data may be shared with service providers when necessary for business operations.
            </p>

            <h2>Storage, Security and Transfer of Data</h2>

            <h3>Cookies</h3>
            <p className="small-text">
              We use cookies to retain preferences and session data. You may disable cookies in your browser settings, which may limit functionality.
            </p>

            <h3>Tracking</h3>
            <p className="small-text">
              We do not track your activity across third-party websites or respond to “Do Not Track” signals.
            </p>

            <h3>Security</h3>
            <p className="small-text">
              Data is hosted in the U.S. using secure providers. While we use protective measures, no system can be 100% secure.
            </p>

            <h3>How Long Is Data Stored?</h3>
            <ul className="small-text">
              <li>Personal Information: Stored until your subscription ends (or longer for legal/operational needs).</li>
              <li>Subscription Data: Archived after expiration and then deleted when appropriate.</li>
              <li>Organizational Service: Retained based on admin control or service necessity.</li>
            </ul>

            <h3>Transmission of Personal Data</h3>
            <p className="small-text">
              By using our site, you consent to data being transferred internationally where needed for standard processing.
            </p>

            <h2>How to Control Your Information</h2>
            <p className="small-text">You have the right to:</p>
            <ul className="small-text">
              <li>Request access to your data.</li>
              <li>Request deletion of your data.</li>
              <li>Opt out of data use or sharing.</li>
              <li>Be free from discrimination when exercising these rights.</li>
            </ul>
            <p className="small-text">
              Contact: <a href="mailto:pharmpreppro@gmail.com">pharmpreppro@gmail.com</a> or via our Contact Us page.
            </p>

            <h2>Update Personal Information</h2>
            <p className="small-text">
              You can manage your info in the Profile section or email us with updates or corrections.
            </p>

            <h2>Other Privacy Information</h2>

            <h3>Maintaining Privacy</h3>
            <p className="small-text">
              Messages sent privately are treated as confidential. Content posted in public areas is not.
            </p>

            <h3>Children</h3>
            <p className="small-text">
              Our services are for users 18+. We do not knowingly collect data from children.
              Contact us if you believe we have collected such data.
            </p>

            <h3>Privacy Policy Changes</h3>
            <p className="small-text">
              We may update this policy. Changes will appear here with an updated effective date.
              For major updates, we may notify users by email or within the product.
            </p>

            <h2>California Privacy Rights</h2>
            <p className="small-text">
              Under CCPA, California residents can request:
              <ul className="small-text">
                <li>Access to personal data collected in the past 12 months.</li>
                <li>Deletion of their personal data.</li>
                <li>Information about how their data is shared.</li>
              </ul>
              We do not sell personal data. To exercise these rights, contact us as noted above.
              We may require verification details before processing requests.
            </p>
          </div>
        </BodyContainer>
        
      </BottomContainer>
      <FooterLinks />
      <Footer />
    </>
  );
}

export default Privacy;
